import { Delete as DeleteIcon } from "@mui/icons-material";
import { Edit as EditIcon } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { pink } from "@mui/material/colors";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Modal from "@mui/material/Modal";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Autosuggest from "react-autosuggest";
import { BATTING, OUT } from "../constants/BattingStatus";
import { BOLD, CATCH, HIT_WICKET, RUN_OUT, STUMP } from "../constants/OutType";
import MathUtil from "../util/MathUtil";
import ExtrasPanel from "./ExtrasPanel";
import "./ScoreBoard.css";
import { radioGroupBoxstyle } from "./ui/RadioGroupBoxStyle";

const ScoreBoard = () => {
  const { t } = useTranslation();
  const [inningNo, setInningNo] = useState(1);
  const [match, setMatch] = useState({
    inning1: { batters: [], bowlers: [] },
    inning2: { batters: [], bowlers: [] },
  });
  const [currentRunStack, setCurrentRunStack] = useState([]);
  const [totalRuns, setTotalRuns] = useState(0);
  const [extras, setExtras] = useState({
    total: 0,
    wide: 0,
    noBall: 0,
    bye: 0,
    legBye: 0,
    penalty: 0,
  });
  const [runsByOver, setRunsByOver] = useState(0);
  const [wicketCount, setWicketCount] = useState(0);
  const [totalOvers, setTotalOvers] = useState(0);
  const [batters, setBatters] = useState([]);
  const [ballCount, setBallCount] = useState(0);
  const [overCount, setOverCount] = useState(0);
  const [recentOvers, setRecentOvers] = useState([]);
  const [batter1, setBatter1] = useState({});
  const [batter2, setBatter2] = useState({});
  const [battingOrder, setBattingOrder] = useState(0);
  const [isBatter1Edited, setBatter1Edited] = useState(false);
  const [isBatter2Edited, setBatter2Edited] = useState(false);
  const [isBowlerEdited, setBowlerEdited] = useState(false);
  const [bowler, setBowler] = useState({});
  const [bowlers, setBowlers] = useState([]);
  const [inputBowler, setInputBowler] = useState("");
  const [isModalOpen, setModalOpen] = React.useState(false);
  const [outType, setOutType] = React.useState("");
  const [runOutPlayerId, setRunOutPlayerId] = React.useState("");
  const [remainingBalls, setRemainingBalls] = useState(0);
  const [remainingRuns, setRemainingRuns] = useState(0);
  const [strikeValue, setStrikeValue] = React.useState("strike");
  const [isNoBall, setNoBall] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [hasNameSuggested, setNameSuggested] = useState(false);
  const [hasMatchEnded, setMatchEnded] = useState(false);

  // 游戏配置状态
  const [gameData, setGameData] = useState({
    batting: "",
    team1: "",
    team2: "",
    maxOver: "5",
  });

  const navigate = useNavigate();

  // 从 localStorage 加载数据
  useEffect(() => {
    try {
      const savedData = localStorage.getItem("data");
      if (savedData) {
        const parsedData = JSON.parse(savedData);
        setGameData(parsedData);
      }
    } catch (error) {
      console.error("Error loading game data:", error);
    }
  }, []);

  // 解构游戏配置
  const { batting, team1, team2 } = gameData;
  const maxOver = parseInt(gameData.maxOver);

  // UI 状态：管理按钮和输入框状态
  const [endInningDisabled, setEndInningDisabled] = useState(true);
  const [endInningText, setEndInningText] = useState("");
  const [batter1NameInput, setBatter1NameInput] = useState("");
  const [batter2NameInput, setBatter2NameInput] = useState("");
  const [batter1NameDisabled, setBatter1NameDisabled] = useState(false);
  const [batter2NameDisabled, setBatter2NameDisabled] = useState(false);
  const [bowlerNameDisabled, setBowlerNameDisabled] = useState(false);
  const [scoreButtonsDisabled, setScoreButtonsDisabled] = useState(true);
  const [isNoBallStyle, setIsNoBallStyle] = useState(false);
  const [showRunOutPlayer, setShowRunOutPlayer] = useState(false);
  const [showRunOutPlayerError, setShowRunOutPlayerError] = useState(false);

  // Extras面板状态
  const [showExtrasPanel, setShowExtrasPanel] = useState(false);
  const [extrasType, setExtrasType] = useState("");

  useEffect(() => {
    setEndInningDisabled(true);
  }, []);

  const handleEndInning = (e) => {
    if (inningNo === 2) {
      navigate("/");
    } else {
      if (batter1.id !== undefined) {
        const { id, name, run, ball, four, six, strikeRate, onStrike } =
          batter1;
        batters.push({
          id,
          name,
          run,
          ball,
          four,
          six,
          strikeRate,
          onStrike,
          battingOrder: batter1.battingOrder,
          battingStatus: BATTING,
        });
      }
      if (batter2.id !== undefined) {
        batters.push({
          id: batter2.id,
          name: batter2.name,
          run: batter2.run,
          ball: batter2.ball,
          four: batter2.four,
          six: batter2.six,
          strikeRate: batter2.strikeRate,
          onStrike: batter2.onStrike,
          battingOrder: batter2.battingOrder,
          battingStatus: BATTING,
        });
      }
      if (bowler.id !== undefined) {
        const currentDisplayOver =
          Math.round((ballCount === 6 ? 1 : ballCount * 0.1) * 10) / 10;
        let isMaidenOver = true;
        let countWicket = 0;
        let countNoBall = 0;
        let countWide = 0;
        const deliveries = ["1", "2", "3", "4", "6", "wd"];
        for (let delivery of currentRunStack) {
          delivery = delivery.toString();
          if (deliveries.includes(delivery) || delivery.includes("nb")) {
            isMaidenOver = false;
          }
          if (delivery === "W") {
            countWicket++;
          }
          if (delivery.includes("nb")) {
            countNoBall++;
          }
          if (delivery.includes("wd")) {
            countWide++;
          }
        }
        if (ballCount !== 6) {
          isMaidenOver = false;
        }
        const index = bowlers.findIndex((blr) => {
          return blr.id === bowler.id;
        });
        if (index !== -1) {
          const existingBowler = bowlers[index];
          const { maiden, wicket, noBall, wide, over } = existingBowler;
          const bowlerTotalOver = over + ballCount / 6;
          existingBowler.over = existingBowler.over + currentDisplayOver;
          existingBowler.maiden = isMaidenOver ? maiden + 1 : maiden;
          existingBowler.run = existingBowler.run + runsByOver;
          existingBowler.wicket = wicket + countWicket;
          existingBowler.noBall = noBall + countNoBall;
          existingBowler.wide = wide + countWide;
          existingBowler.economy =
            Math.round((existingBowler.run / bowlerTotalOver) * 100) / 100;
          bowlers[index] = existingBowler;
          setBowlers(bowlers);
        } else {
          if (ballCount !== 6) {
            bowlers.push({
              id: bowler.id,
              name: bowler.name,
              over: currentDisplayOver,
              maiden: isMaidenOver ? 1 : 0,
              run: runsByOver,
              wicket: countWicket,
              noBall: countNoBall,
              wide: countWide,
              economy: Math.round((runsByOver / (ballCount / 6)) * 100) / 100,
            });
            setBowlers(bowlers);
          }
        }
      }
      if (inningNo === 1) {
        setMatch((state) => {
          const totalFours = batters
            .map((batter) => batter.four)
            .reduce((prev, next) => prev + next, 0);
          const totalSixes = batters
            .map((batter) => batter.six)
            .reduce((prev, next) => prev + next, 0);
          return {
            ...state,
            inning1: {
              runs: totalRuns,
              wickets: wicketCount,
              runRate: crr,
              overs: totalOvers,
              four: totalFours,
              six: totalSixes,
              extra: extras,
              batters,
              bowlers,
            },
          };
        });
        setInningNo(2);
        setCurrentRunStack([]);
        setTotalRuns(0);
        setExtras({
          total: 0,
          wide: 0,
          noBall: 0,
          bye: 0,
          legBye: 0,
          penalty: 0,
        });
        setRunsByOver(0);
        setWicketCount(0);
        setTotalOvers(0);
        setBallCount(0);
        setOverCount(0);
        setRecentOvers([]);
        setBatter1({});
        setBatter2({});
        setBatters([]);
        setBowlers([]);
        setBattingOrder(0);
        setInputBowler("");
        setBowler({});
        setRemainingBalls(maxOver * 6);
        setRemainingRuns(totalRuns + 1);
        setBatter1NameInput("");
        setBatter1NameDisabled(false);
        setBatter2NameInput("");
        setBatter2NameDisabled(false);
        setBowlerNameDisabled(false);
        setStrikeValue("strike");
        setEndInningDisabled(true);
      } else {
        setMatch((state) => {
          const totalFours = batters
            .map((batter) => batter.four)
            .reduce((prev, next) => prev + next, 0);
          const totalSixes = batters
            .map((batter) => batter.six)
            .reduce((prev, next) => prev + next, 0);
          return {
            ...state,
            inning2: {
              runs: totalRuns,
              wickets: wicketCount,
              runRate: crr,
              overs: totalOvers,
              four: totalFours,
              six: totalSixes,
              extra: extras,
              batters,
              bowlers,
            },
          };
        });
        endInningButton.textContent = "Reset";
        setMatchEnded(true);
      }
    }
  };
  const handleBatter1Blur = (e) => {
    let name = e.target.value;
    name = name.charAt(0).toUpperCase() + name.slice(1);
    setBatter1NameInput(name);
    setBatter1NameDisabled(true);
    if (isBatter1Edited) {
      setBatter1((state) => ({
        ...state,
        name: name,
      }));
      setBatter1Edited(false);
    } else {
      const randomNo = MathUtil.getRandomNo();
      setBatter1({
        id: name + randomNo,
        name: name,
        run: 0,
        ball: 0,
        four: 0,
        six: 0,
        strikeRate: 0,
        onStrike: strikeValue === "strike" ? true : false,
        battingOrder: battingOrder + 1,
        battingStatus: BATTING,
      });
      setBattingOrder(battingOrder + 1);
    }
  };
  const handleBatter2Blur = (e) => {
    let name = e.target.value;
    name = name.charAt(0).toUpperCase() + name.slice(1);
    setBatter2NameInput(name);
    setBatter2NameDisabled(true);
    if (isBatter2Edited) {
      setBatter2((state) => ({
        ...state,
        name: name,
      }));
      setBatter2Edited(false);
    } else {
      const randomNo = MathUtil.getRandomNo();
      setBatter2({
        id: name + randomNo,
        name: name,
        run: 0,
        ball: 0,
        four: 0,
        six: 0,
        strikeRate: 0,
        onStrike: strikeValue === "non-strike" ? true : false,
        battingOrder: battingOrder + 1,
        battingStatus: BATTING,
      });
      setBattingOrder(battingOrder + 1);
    }
  };
  const handleBowlerBlur = (e) => {
    let name = e.target.value;
    if (name !== "") {
      name = name.charAt(0).toUpperCase() + name.slice(1);
      setInputBowler(name);
      e.target.value = name;
      setBowlerNameDisabled(true);
      if (isBowlerEdited) {
        setBowler((state) => ({
          ...state,
          name: name,
        }));
        setBowlerEdited(false);
      } else {
        if (hasNameSuggested) {
          setNameSuggested(false);
        } else {
          const randomNo = MathUtil.getRandomNo();
          const id = name + randomNo;
          setBowler({
            id,
            name,
          });
        }
      }
    }
  };
  const onSuggestionsFetchRequested = (param) => {
    const inputValue = param.value.trim().toLowerCase();
    const suggestionArr =
      inputValue.length === 0
        ? []
        : bowlers.filter((bowlerObj) =>
            bowlerObj.name.toLowerCase().includes(inputValue),
          );
    setSuggestions(suggestionArr);
  };
  const getSuggestionValue = (suggestion) => {
    setBowler({
      id: suggestion.id,
      name: suggestion.name,
    });
    setNameSuggested(true);
    return suggestion.name;
  };
  const inputProps = {
    value: inputBowler,
    onChange: (e, { newValue }) => {
      setInputBowler(newValue);
    },
    onBlur: handleBowlerBlur,
    disabled: bowlerNameDisabled,
  };
  const overCompleted = (runsByOverParam, currentRunStackParam) => {
    if (overCount + 1 === maxOver) {
      setEndInningDisabled(false);
    } else {
      setBowlerNameDisabled(false);
    }
    setScoreButtonsDisabled(true);
    setRecentOvers((state) => [
      ...state,
      {
        overNo: overCount + 1,
        bowler: bowler.name,
        runs: runsByOverParam,
        stack: currentRunStackParam,
      },
    ]);
    setInputBowler("");
    setBowler({});
    setCurrentRunStack([]);
    setRunsByOver(0);
    setBallCount(0);
    setOverCount(overCount + 1);
    const index = bowlers.findIndex((blr) => blr.id === bowler.id);
    let isMaidenOver = true;
    let countWicket = 0;
    let countNoBall = 0;
    let countWide = 0;
    const deliveries = ["1", "2", "3", "4", "6", "wd"];
    for (let delivery of currentRunStackParam) {
      delivery = delivery.toString();
      if (deliveries.includes(delivery) || delivery.includes("nb")) {
        isMaidenOver = false;
      }
      if (delivery === "W") {
        countWicket++;
      }
      if (delivery.includes("nb")) {
        countNoBall++;
      }
      if (delivery.includes("wd")) {
        countWide++;
      }
    }
    if (index !== -1) {
      const existingBowler = bowlers[index];
      const { over, maiden, run, wicket, noBall, wide } = existingBowler;
      existingBowler.over = over + 1;
      existingBowler.maiden = isMaidenOver ? maiden + 1 : maiden;
      existingBowler.run = run + runsByOverParam;
      existingBowler.wicket = wicket + countWicket;
      existingBowler.noBall = noBall + countNoBall;
      existingBowler.wide = wide + countWide;
      existingBowler.economy =
        Math.round((existingBowler.run / existingBowler.over) * 100) / 100;
      bowlers[index] = existingBowler;
      setBowlers(bowlers);
    } else {
      setBowlers((state) => [
        ...state,
        {
          id: bowler.id,
          name: bowler.name,
          over: 1,
          maiden: isMaidenOver ? 1 : 0,
          run: runsByOverParam,
          wicket: countWicket,
          noBall: countNoBall,
          wide: countWide,
          economy: runsByOverParam,
        },
      ]);
    }
  };
  const newBatter1 = () => {
    const { id, name, run, ball, four, six, strikeRate, onStrike } = batter1;
    setBatters((state) => [
      ...state,
      {
        id,
        name,
        run,
        ball,
        four,
        six,
        strikeRate,
        onStrike,
        battingOrder: batter1.battingOrder,
        battingStatus: OUT,
      },
    ]);
    setBatter1({});
    setBatter1NameInput("");
    setBatter1NameDisabled(false);
  };
  const newBatter2 = () => {
    const { id, name, run, ball, four, six, strikeRate, onStrike } = batter2;
    setBatters((state) => [
      ...state,
      {
        id,
        name,
        run,
        ball,
        four,
        six,
        strikeRate,
        onStrike,
        battingOrder: batter2.battingOrder,
        battingStatus: OUT,
      },
    ]);
    setBatter2({});
    setBatter2NameInput("");
    setBatter2NameDisabled(false);
  };
  const editBatter1Name = () => {
    if (overCount !== maxOver && wicketCount !== 10 && !hasMatchEnded) {
      setBatter1NameDisabled(false);
      setBatter1Edited(true);
    }
  };
  const editBatter2Name = () => {
    if (overCount !== maxOver && wicketCount !== 10 && !hasMatchEnded) {
      setBatter2NameDisabled(false);
      setBatter2Edited(true);
    }
  };
  const editBowlerName = () => {
    if (overCount !== maxOver && wicketCount !== 10 && !hasMatchEnded) {
      setBowlerNameDisabled(false);
      setBowlerEdited(true);
    }
  };
  const undoWicket = (isNoBallParam) => {
    // 第2局特殊处理：回退剩余球数
    if (inningNo === 2 && !isNoBallParam) {
      setRemainingBalls(remainingBalls + 1);
    }

    if (!isNoBallParam) {
      setBallCount(ballCount - 1);
      setTotalOvers(Math.round((totalOvers - 0.1) * 10) / 10);
    }
    setWicketCount(wicketCount - 1);
    const batter = batters[batters.length - 1];
    const { id, name, run, ball, four, six, strikeRate, onStrike } = batter;
    if (batter1.name === undefined || batter1.onStrike) {
      setBatter1({
        id,
        name,
        run,
        ball,
        four,
        six,
        strikeRate,
        onStrike,
        battingOrder: batter.battingOrder,
        battingStatus: BATTING,
      });
      setBatter1NameInput(batter.name);
      setBatter1NameDisabled(true);
      if (!batter.onStrike) {
        changeStrikeRadio();
        setBatter2((state) => ({
          ...state,
          onStrike: true,
        }));
      }
    } else if (batter2.name === undefined || batter2.onStrike) {
      setBatter2({
        id,
        name,
        run,
        ball,
        four,
        six,
        strikeRate,
        onStrike,
        battingOrder: batter.battingOrder,
        battingStatus: BATTING,
      });
      setBatter2NameInput(batter.name);
      setBatter2NameDisabled(true);
      if (!batter.onStrike) {
        changeStrikeRadio();
        setBatter1((state) => ({
          ...state,
          onStrike: true,
        }));
      }
    }
    batters.pop();
    setBatters(batters);
  };
  const undoRun = (run, isNoBallParam) => {
    // 第2局特殊处理：回退剩余球数和剩余得分
    if (inningNo === 2) {
      if (isNoBallParam) {
        setRemainingRuns(remainingRuns + (run + 1));
        // NoBall不消耗球数
      } else {
        setRemainingRuns(remainingRuns + run);
        setRemainingBalls(remainingBalls + 1);
      }
    }

    if (isNoBallParam) {
      setTotalRuns(Math.max(0, totalRuns - (run + 1)));
      setRunsByOver(Math.max(0, runsByOver - (run + 1)));
    } else {
      setTotalRuns(Math.max(0, totalRuns - run));
      setRunsByOver(Math.max(0, runsByOver - run));
      setBallCount(Math.max(0, ballCount - 1));
      setTotalOvers(Math.max(0, Math.round((totalOvers - 0.1) * 10) / 10));
      currentRunStack.pop();
      setCurrentRunStack([...currentRunStack]);
    }
    if (batter1.onStrike) {
      if (run % 2 === 0) {
        setBatter1((state) => {
          const updatedRun = Math.max(0, state.run - run);
          const updatedBall = isNoBallParam ? state.ball : Math.max(0, state.ball - 1); // NoBall不回退有效球数
          const updatedSr = updatedBall > 0 ? updatedRun / updatedBall : 0;
          const sr =
            Math.round(isNaN(updatedSr) ? 0 : updatedSr * 100 * 100) / 100;
          let four = state.four;
          if (run === 4) {
            four = Math.max(0, four - 1);
          }
          let six = state.six;
          if (run === 6) {
            six = Math.max(0, six - 1);
          }
          return {
            ...state,
            run: updatedRun,
            ball: updatedBall,
            four: four,
            six: six,
            strikeRate: sr,
          };
        });
      } else {
        changeStrikeRadio();
        switchBatterStrike();
        setBatter2((state) => {
          const updatedRun = Math.max(0, state.run - run);
          const updatedBall = isNoBallParam ? state.ball : Math.max(0, state.ball - 1); // NoBall不回退有效球数
          const updatedSr = updatedBall > 0 ? updatedRun / updatedBall : 0;
          const sr =
            Math.round(isNaN(updatedSr) ? 0 : updatedSr * 100 * 100) / 100;
          let four = state.four;
          if (run === 4) {
            four = Math.max(0, four - 1);
          }
          let six = state.six;
          if (run === 6) {
            six = Math.max(0, six - 1);
          }
          return {
            ...state,
            run: updatedRun,
            ball: updatedBall,
            four: four,
            six: six,
            strikeRate: sr,
          };
        });
      }
    } else if (batter2.onStrike) {
      if (run % 2 === 0) {
        setBatter2((state) => {
          const updatedRun = Math.max(0, state.run - run);
          const updatedBall = isNoBallParam ? state.ball : Math.max(0, state.ball - 1); // NoBall不回退有效球数
          const updatedSr = updatedBall > 0 ? updatedRun / updatedBall : 0;
          const sr =
            Math.round(isNaN(updatedSr) ? 0 : updatedSr * 100 * 100) / 100;
          let four = state.four;
          if (run === 4) {
            four = Math.max(0, four - 1);
          }
          let six = state.six;
          if (run === 6) {
            six = Math.max(0, six - 1);
          }
          return {
            ...state,
            run: updatedRun,
            ball: updatedBall,
            four: four,
            six: six,
            strikeRate: sr,
          };
        });
      } else {
        changeStrikeRadio();
        switchBatterStrike();
        setBatter1((state) => {
          const updatedRun = Math.max(0, state.run - run);
          const updatedBall = isNoBallParam ? state.ball : Math.max(0, state.ball - 1); // NoBall不回退有效球数
          const updatedSr = updatedBall > 0 ? updatedRun / updatedBall : 0;
          const sr =
            Math.round(isNaN(updatedSr) ? 0 : updatedSr * 100 * 100) / 100;
          let four = state.four;
          if (run === 4) {
            four = Math.max(0, four - 1);
          }
          let six = state.six;
          if (run === 6) {
            six = Math.max(0, six - 1);
          }
          return {
            ...state,
            run: updatedRun,
            ball: updatedBall,
            four: four,
            six: six,
            strikeRate: sr,
          };
        });
      }
    }
  };
  const undoDelivery = () => {
    if (currentRunStack.length > 0) {
      const last = currentRunStack[currentRunStack.length - 1];
      if (typeof last === "number") {
        const run = parseInt(last);
        undoRun(run, false);
      } else {
        currentRunStack.pop();
        setCurrentRunStack([...currentRunStack]);

        if (last === "wd") {
          // 撤销宽球
          setTotalRuns(Math.max(0, totalRuns - 1));
          setExtras((state) => ({
            ...state,
            total: Math.max(0, state.total - 1),
            wide: Math.max(0, state.wide - 1),
          }));

          // 第2局特殊处理：回退剩余得分
          if (inningNo === 2) {
            setRemainingRuns(remainingRuns + 1);
          }
        } else if (last === "nb") {
          // 撤销不合法球（无跑分）
          setNoBall(false);
          setTotalRuns(Math.max(0, totalRuns - 1));
          setRunsByOver(Math.max(0, runsByOver - 1));
          setExtras((state) => ({
            ...state,
            total: Math.max(0, state.total - 1),
            noBall: Math.max(0, state.noBall - 1),
          }));

          // 第2局特殊处理：回退剩余得分
          if (inningNo === 2) {
            setRemainingRuns(remainingRuns + 1);
          }
        } else if (last === "W") {
          // 撤销出局
          undoWicket(false);
        } else if (last === "P") {
          // 撤销罚分
          setTotalRuns(Math.max(0, totalRuns - 5));
          setRunsByOver(Math.max(0, runsByOver - 5));
          setExtras((state) => ({
            ...state,
            total: Math.max(0, state.total - 5),
            penalty: Math.max(0, (state.penalty || 0) - 5),
          }));

          // 第2局特殊处理：回退剩余得分
          if (inningNo === 2) {
            setRemainingRuns(remainingRuns + 5);
          }
        } else if (last.startsWith("nb")) {
          // 撤销不合法球+跑分
          const lastChar = last.substr(last.length - 1);
          const run = parseInt(lastChar);
          if (!isNaN(run)) {
            setNoBall(false);
            setTotalRuns(Math.max(0, totalRuns - (run + 1)));
            setRunsByOver(Math.max(0, runsByOver - (run + 1)));
            setExtras((state) => ({
              ...state,
              total: Math.max(0, state.total - (run + 1)),
              noBall: Math.max(0, state.noBall - 1),
            }));

            // 第2局特殊处理：回退剩余得分
            if (inningNo === 2) {
              setRemainingRuns(remainingRuns + (run + 1));
            }

            // 回退击球手个人数据（不合法球+击球情况）
            if (run > 0) {
              if (batter1.onStrike) {
                setBatter1((state) => {
                  const updatedRun = Math.max(0, state.run - run);
                  const updatedBall = state.ball; // NoBall不增加球数
                  const updatedSr = updatedBall > 0 ? updatedRun / updatedBall : 0;
                  const sr = Math.round(updatedSr * 100 * 100) / 100;
                  let four = state.four;
                  if (run === 4) {
                    four = Math.max(0, four - 1);
                  }
                  let six = state.six;
                  if (run === 6) {
                    six = Math.max(0, six - 1);
                  }
                  return {
                    ...state,
                    run: updatedRun,
                    ball: updatedBall,
                    four: four,
                    six: six,
                    strikeRate: sr,
                  };
                });
              } else if (batter2.onStrike) {
                setBatter2((state) => {
                  const updatedRun = Math.max(0, state.run - run);
                  const updatedBall = state.ball;
                  const updatedSr = updatedBall > 0 ? updatedRun / updatedBall : 0;
                  const sr = Math.round(updatedSr * 100 * 100) / 100;
                  let four = state.four;
                  if (run === 4) {
                    four = Math.max(0, four - 1);
                  }
                  let six = state.six;
                  if (run === 6) {
                    six = Math.max(0, six - 1);
                  }
                  return {
                    ...state,
                    run: updatedRun,
                    ball: updatedBall,
                    four: four,
                    six: six,
                    strikeRate: sr,
                  };
                });
              }
            }

            // NoBall奇数跑分需要换边
            if (run % 2 !== 0) {
              changeStrikeRadio();
            }
          }
        } else if (last.startsWith("wd")) {
          // 撤销宽球+跑分
          const lastChar = last.substr(last.length - 1);
          const run = parseInt(lastChar);
          if (!isNaN(run)) {
            const totalRunsAdded = 1 + run;
            setTotalRuns(Math.max(0, totalRuns - totalRunsAdded));
            setRunsByOver(Math.max(0, runsByOver - totalRunsAdded));
            setExtras((state) => ({
              ...state,
              total: Math.max(0, state.total - totalRunsAdded),
              wide: Math.max(0, state.wide - 1),
            }));

            // 第2局特殊处理：回退剩余得分
            if (inningNo === 2) {
              setRemainingRuns(remainingRuns + totalRunsAdded);
            }
          }
        } else if (last.startsWith("bye")) {
          // 撤销Bye跑分
          const lastChar = last.substr(last.length - 1);
          const run = parseInt(lastChar);
          if (!isNaN(run)) {
            setTotalRuns(Math.max(0, totalRuns - run));
            setRunsByOver(Math.max(0, runsByOver - run));
            setExtras((state) => ({
              ...state,
              total: Math.max(0, state.total - run),
              bye: Math.max(0, state.bye - run),
            }));

            // 第2局特殊处理：回退剩余得分和剩余球数
            if (inningNo === 2) {
              setRemainingRuns(remainingRuns + run);
              setRemainingBalls(remainingBalls + 1);
            }
          }
        } else if (last.startsWith("legbye")) {
          // 撤销Leg Bye跑分
          const lastChar = last.substr(last.length - 1);
          const run = parseInt(lastChar);
          if (!isNaN(run)) {
            setTotalRuns(Math.max(0, totalRuns - run));
            setRunsByOver(Math.max(0, runsByOver - run));
            setExtras((state) => ({
              ...state,
              total: Math.max(0, state.total - run),
              legBye: Math.max(0, state.legBye - run),
            }));

            // 第2局特殊处理：回退剩余得分和剩余球数
            if (inningNo === 2) {
              setRemainingRuns(remainingRuns + run);
              setRemainingBalls(remainingBalls + 1);
            }
          }
        } else if (last === "nbW") {
          // 撤销不合法球+出局
          setNoBall(false);
          setTotalRuns(Math.max(0, totalRuns - 1));
          setRunsByOver(Math.max(0, runsByOver - 1));
          setExtras((state) => ({
            ...state,
            total: Math.max(0, state.total - 1),
            noBall: Math.max(0, state.noBall - 1),
          }));

          // 第2局特殊处理：回退剩余得分
          if (inningNo === 2) {
            setRemainingRuns(remainingRuns + 1);
          }

          undoWicket(true);
        } else {
          const lastChar = last.substr(last.length - 1);
          const run = parseInt(lastChar);
          if (isNaN(run)) {
            setTotalRuns(Math.max(0, totalRuns - 1));
            setRunsByOver(Math.max(0, runsByOver - 1));
            if (last !== "nb") {
              undoWicket(true);
            }
          } else {
            undoRun(run, true);
          }
        }
      }
    }
  };
  const handleStrikeChange = (e) => {
    changeStrikeRadio(e.target.value);
    if (e.target.value === "strike") {
      switchBatterStrike("batter1");
    } else {
      switchBatterStrike("batter2");
    }
  };
  const changeStrikeRadio = (strikeParam) => {
    if (strikeParam === undefined) {
      setStrikeValue(strikeValue === "strike" ? "non-strike" : "strike");
    } else {
      setStrikeValue(strikeParam);
    }
  };
  const switchBatterStrike = (strikeParam) => {
    if (strikeParam === undefined) {
      setBatter1((state) => ({
        ...state,
        onStrike: !state.onStrike,
      }));
      setBatter2((state) => ({
        ...state,
        onStrike: !state.onStrike,
      }));
    } else {
      if (strikeParam === "batter1") {
        setBatter1((state) => ({
          ...state,
          onStrike: true,
        }));
        setBatter2((state) => ({
          ...state,
          onStrike: false,
        }));
      } else if (strikeParam === "batter2") {
        setBatter1((state) => ({
          ...state,
          onStrike: false,
        }));
        setBatter2((state) => ({
          ...state,
          onStrike: true,
        }));
      }
    }
  };
  const handleRun = (run) => {
    if (isNoBall) {
      setCurrentRunStack((state) => [...state, "nb" + run]);
      removeNoBallEffect();
    } else {
      setBallCount(ballCount + 1);
      setCurrentRunStack((state) => [...state, run]);
    }
    setTotalRuns(totalRuns + run);
    setRunsByOver(runsByOver + run);
    if (inningNo === 2) {
      if (!isNoBall) {
        setRemainingBalls(remainingBalls - 1);
      }
      setRemainingRuns(remainingRuns - run);
    }
    if (ballCount === 5) {
      if (isNoBall) {
        if (run % 2 !== 0) {
          changeStrikeRadio();
        }
      } else {
        setTotalOvers(overCount + 1);
        const arr = [...currentRunStack];
        arr.push(run);
        overCompleted(runsByOver + run, arr);
        if (run % 2 === 0) {
          changeStrikeRadio();
        }
      }
    } else {
      if (!isNoBall) {
        setTotalOvers(Math.round((totalOvers + 0.1) * 10) / 10);
      }
      if (run % 2 !== 0) {
        changeStrikeRadio();
      }
    }
    if (batter1.onStrike) {
      setBatter1((state) => {
        const updatedRun = state.run + run;
        const updatedBall = isNoBall ? state.ball : state.ball + 1; // NoBall和Wide不增加有效球数
        const sr = Math.round((updatedRun / updatedBall) * 100 * 100) / 100;
        let four = state.four;
        if (run === 4) {
          four = four + 1;
        }
        let six = state.six;
        if (run === 6) {
          six = six + 1;
        }
        return {
          ...state,
          run: updatedRun,
          ball: updatedBall,
          four: four,
          six: six,
          strikeRate: sr,
        };
      });
      if (isNoBall) {
        if (run % 2 !== 0) {
          switchBatterStrike();
        }
      } else {
        if (
          (ballCount === 5 && run % 2 === 0) ||
          (ballCount !== 5 && run % 2 !== 0)
        ) {
          switchBatterStrike();
        }
      }
    } else {
      setBatter2((state) => {
        const updatedRun = state.run + run;
        const updatedBall = isNoBall ? state.ball : state.ball + 1; // NoBall和Wide不增加有效球数
        const sr = Math.round((updatedRun / updatedBall) * 100 * 100) / 100;
        let four = state.four;
        if (run === 4) {
          four = four + 1;
        }
        let six = state.six;
        if (run === 6) {
          six = six + 1;
        }
        return {
          ...state,
          run: updatedRun,
          ball: updatedBall,
          four: four,
          six: six,
          strikeRate: sr,
        };
      });
      if (
        (ballCount === 5 && run % 2 === 0) ||
        (ballCount !== 5 && run % 2 !== 0)
      ) {
        switchBatterStrike();
      }
    }
  };
  const handleNoBall = () => {
    if (inningNo === 2) {
      setRemainingRuns(remainingRuns - 1);
    }
    setTotalRuns(totalRuns + 1);
    setRunsByOver(runsByOver + 1);
    setExtras((state) => ({
      ...state,
      total: state.total + 1,
      noBall: state.noBall + 1,
    }));
    addNoBallEffect();
  };
  const addNoBallEffect = () => {
    const scoreTypesButtons = document.querySelectorAll(".score-types-button");
    for (let i = 0; i < scoreTypesButtons.length; i++) {
      scoreTypesButtons[i].classList.add("score-types-button-noball");
    }
    setNoBall(true);
  };
  const removeNoBallEffect = () => {
    const scoreTypesButtons = document.querySelectorAll(".score-types-button");
    for (let i = 0; i < scoreTypesButtons.length; i++) {
      scoreTypesButtons[i].classList.remove("score-types-button-noball");
    }
    setNoBall(false);
  };
  const handleWide = () => {
    if (isNoBall) {
      setCurrentRunStack((state) => [...state, "nb"]);
      removeNoBallEffect();
    } else {
      if (inningNo === 2) {
        setRemainingRuns(remainingRuns - 1);
      }
      setCurrentRunStack((state) => [...state, "wd"]);
      setTotalRuns(totalRuns + 1);
      setRunsByOver(runsByOver + 1);
      setExtras((state) => ({
        ...state,
        total: state.total + 1,
        wide: state.wide + 1,
      }));
    }
  };

  // Extras面板处理函数
  const handleWideExtrasClick = () => {
    setExtrasType("wide");
    setShowExtrasPanel(true);
  };

  const handleNoBallExtrasClick = (isHit) => {
    setExtrasType(`noball-${isHit ? "hit" : "run"}`);
    setShowExtrasPanel(true);
  };

  // 宽球基础1分处理
  const handleWideBasic = () => {
    setCurrentRunStack((state) => [...state, "wd"]);
    setTotalRuns(totalRuns + 1);
    setRunsByOver(runsByOver + 1);
    setExtras((state) => ({
      ...state,
      total: state.total + 1,
      wide: state.wide + 1,
    }));

    // 第2局特殊处理
    if (inningNo === 2) {
      setRemainingRuns(remainingRuns - 1);
    }
  };

  // 无击球基础1分处理
  const handleNoBallBasic = () => {
    setCurrentRunStack((state) => [...state, "nb"]);
    setTotalRuns(totalRuns + 1);
    setRunsByOver(runsByOver + 1);
    setExtras((state) => ({
      ...state,
      total: state.total + 1,
      noBall: state.noBall + 1,
    }));

    // 第2局特殊处理
    if (inningNo === 2) {
      setRemainingRuns(remainingRuns - 1);
    }
  };

  const handleByeClick = () => {
    setExtrasType("bye");
    setShowExtrasPanel(true);
  };

  const handleLegByeClick = () => {
    setExtrasType("legbye");
    setShowExtrasPanel(true);
  };

  const handleExtrasSelect = useCallback(
    (run) => {
      if (extrasType === "wide") {
        handleWideWithExtras(run);
      } else if (extrasType === "legbye") {
        handleLegByeRun(run);
      } else if (extrasType === "bye") {
        handleByeRun(run);
      } else if (extrasType.startsWith("noball-")) {
        const isHit = extrasType.endsWith("hit");
        handleNoBallWithExtras(run, isHit);
      }
      setShowExtrasPanel(false);
      setExtrasType("");
    },
    [extrasType, inningNo, remainingRuns, ballCount, currentRunStack],
  );

  // 宽球+跑分处理
  const handleWideWithExtras = (run = 0) => {
    const totalRunsAdded = 1 + run;
    setCurrentRunStack((state) => [...state, run > 0 ? `wd${run}` : "wd"]);
    setTotalRuns(totalRuns + totalRunsAdded);
    setRunsByOver(runsByOver + totalRunsAdded);
    setExtras((state) => ({
      ...state,
      total: state.total + totalRunsAdded,
      wide: state.wide + totalRunsAdded,
    }));

    // 第2局特殊处理
    if (inningNo === 2) {
      setRemainingRuns(remainingRuns - totalRunsAdded);
    }
  };

  // 无击球+跑分处理
  const handleNoBallWithExtras = (run = 0, isHit = false) => {
    // NoBall基础1分始终计入extras
    setExtras((state) => ({
      ...state,
      total: state.total + 1,
      noBall: state.noBall + 1,
    }));

    if (isHit) {
      // 击球情况：run计入击球员个人得分，基础1分计入extras
      if (run > 0) {
        // 更新击球员数据
        if (batter1.onStrike) {
          setBatter1((state) => {
            const updatedRun = state.run + run;
            const updatedBall = state.ball; // NoBall不增加球数
            const sr = Math.round((updatedRun / updatedBall) * 100 * 100) / 100;
            let four = state.four;
            if (run === 4) four = four + 1;
            let six = state.six;
            if (run === 6) six = six + 1;
            return {
              ...state,
              run: updatedRun,
              ball: updatedBall,
              four: four,
              six: six,
              strikeRate: sr,
            };
          });
          // NoBall奇数跑分换边
          if (run % 2 !== 0) {
            changeStrikeRadio();
            switchBatterStrike();
          }
        } else if (batter2.onStrike) {
          setBatter2((state) => {
            const updatedRun = state.run + run;
            const updatedBall = state.ball;
            const sr = Math.round((updatedRun / updatedBall) * 100 * 100) / 100;
            let four = state.four;
            if (run === 4) four = four + 1;
            let six = state.six;
            if (run === 6) six = six + 1;
            return {
              ...state,
              run: updatedRun,
              ball: updatedBall,
              four: four,
              six: six,
              strikeRate: sr,
            };
          });
          if (run % 2 !== 0) {
            changeStrikeRadio();
            switchBatterStrike();
          }
        }
      }

      setCurrentRunStack((state) => [...state, `nb${run}`]);
      setTotalRuns(totalRuns + 1 + run);
      setRunsByOver(runsByOver + 1 + run);

      // 第2局特殊处理
      if (inningNo === 2) {
        setRemainingRuns(remainingRuns - (1 + run));
      }
    } else {
      // 未击球跑分情况：所有分数（包括基础1分）计入extras
      const totalRunsAdded = 1 + run;
      setCurrentRunStack((state) => [...state, `nb${run}`]);
      setTotalRuns(totalRuns + totalRunsAdded);
      setRunsByOver(runsByOver + totalRunsAdded);
      setBallCount(ballCount); // NoBall不增加有效球数

      // 第2局特殊处理
      if (inningNo === 2) {
        setRemainingRuns(remainingRuns - totalRunsAdded);
      }

      // 球数满6的处理（NoBall不增加有效球数，不触发局数结束）
      if (run % 2 !== 0) {
        changeStrikeRadio();
      }
    }
  };

  // Bye跑分处理
  const handleByeRun = (run) => {
    const totalRunsAdded = run;
    setCurrentRunStack((state) => [...state, `bye${run}`]);
    setTotalRuns(totalRuns + totalRunsAdded);
    setRunsByOver(runsByOver + totalRunsAdded);
    setBallCount(ballCount + 1);
    setExtras((state) => ({
      ...state,
      total: state.total + totalRunsAdded,
      bye: state.bye + totalRunsAdded,
    }));

    // 第2局特殊处理
    if (inningNo === 2) {
      setRemainingRuns(remainingRuns - totalRunsAdded);
    }

    // 球数满6的处理
    if (ballCount === 5) {
      setTotalOvers(overCount + 1);
      const arr = [...currentRunStack, `bye${run}`];
      overCompleted(runsByOver + totalRunsAdded, arr);
      if (run % 2 === 0) {
        changeStrikeRadio();
      }
    }
  };

  // Leg Bye跑分处理
  const handleLegByeRun = (run) => {
    const totalRunsAdded = run;
    setCurrentRunStack((state) => [...state, `lb${run}`]);
    setTotalRuns(totalRuns + totalRunsAdded);
    setRunsByOver(runsByOver + totalRunsAdded);
    setBallCount(ballCount + 1);
    setExtras((state) => ({
      ...state,
      total: state.total + totalRunsAdded,
      legBye: state.legBye + totalRunsAdded,
    }));

    // 第2局特殊处理
    if (inningNo === 2) {
      setRemainingRuns(remainingRuns - totalRunsAdded);
    }

    // 球数满6的处理
    if (ballCount === 5) {
      setTotalOvers(overCount + 1);
      const arr = [...currentRunStack, `lb${run}`];
      overCompleted(runsByOver + totalRunsAdded, arr);
      if (run % 2 === 0) {
        changeStrikeRadio();
      }
    }
  };

  // 罚分处理
  const handlePenaltyRun = () => {
    const penaltyRuns = 5;
    setCurrentRunStack((state) => [...state, "P"]);
    setTotalRuns(totalRuns + penaltyRuns);
    setRunsByOver(runsByOver + penaltyRuns);
    setExtras((state) => ({
      ...state,
      total: state.total + penaltyRuns,
      penalty: (state.penalty || 0) + penaltyRuns,
    }));
    // 罚分不消耗球数，不触发轮换
  };
  const handleWicket = (isRunOut, playerId) => {
    setRunOutPlayerId("");
    if (ballCount === 5) {
      if (isNoBall) {
        removeNoBallEffect();
        if (isRunOut) {
          setCurrentRunStack((state) => [...state, "nbW"]);
          setWicketCount(wicketCount + 1);
          disableAllScoreButtons();
        } else {
          setCurrentRunStack((state) => [...state, "nb"]);
        }
      } else {
        setTotalOvers(overCount + 1);
        const arr = [...currentRunStack];
        arr.push("W");
        overCompleted(runsByOver, arr);
        setWicketCount(wicketCount + 1);
        disableAllScoreButtons();
      }
    } else {
      if (isNoBall) {
        removeNoBallEffect();
        if (isRunOut) {
          setCurrentRunStack((state) => [...state, "nbW"]);
          setWicketCount(wicketCount + 1);
          disableAllScoreButtons();
        } else {
          setCurrentRunStack((state) => [...state, "nb"]);
        }
      } else {
        setBallCount(ballCount + 1);
        setCurrentRunStack((state) => [...state, "W"]);
        setTotalOvers(Math.round((totalOvers + 0.1) * 10) / 10);
        setWicketCount(wicketCount + 1);
        disableAllScoreButtons();
      }
    }
    if (isRunOut) {
      if (batter1.id === playerId) {
        newBatter1();
        changeStrikeRadio("strike");
        switchBatterStrike("batter1");
      } else {
        newBatter2();
        changeStrikeRadio("non-strike");
        switchBatterStrike("batter2");
      }
    } else {
      if (!isNoBall) {
        if (batter1.onStrike) {
          newBatter1();
        } else {
          newBatter2();
        }
      }
    }
    if (isNoBall) {
      if (isRunOut && wicketCount + 1 === 10) {
        setEndInningDisabled(false);
        setBowlerNameDisabled(true);
        setBatter1NameDisabled(true);
        setBatter2NameDisabled(true);
        setInputBowler("");
      }
    } else {
      if (wicketCount + 1 === 10) {
        setEndInningDisabled(false);
        setBowlerNameDisabled(true);
        setBatter1NameDisabled(true);
        setBatter2NameDisabled(true);
        setInputBowler("");
      }
    }
  };
  const handleCloseModal = () => {
    if (outType !== "") {
      if (outType === RUN_OUT) {
        if (runOutPlayerId !== "") {
          handleWicket(true, runOutPlayerId);
        }
      } else {
        handleWicket(false, "");
      }
    }
    setModalOpen(false);
    setOutType("");
    setRunOutPlayerId("");
    setShowRunOutPlayer(false);
    setShowRunOutPlayerError(false);
  };
  const handleOutTypeChange = (e) => {
    const outTypeValue = e.target.value;
    setOutType(outTypeValue);

    // 如果是跑杀类型，显示球员选择下拉框
    if (outTypeValue === RUN_OUT) {
      setShowRunOutPlayer(true);
      setShowRunOutPlayerError(true);
    } else {
      // 其他类型选择后立即关闭模态框并处理出局
      handleWicket(false, "");
      setModalOpen(false);
      setOutType("");
    }
  };

  const handleRunOutPlayerChange = (e) => {
    const playerId = e.target.value;
    setShowRunOutPlayerError(false);
    setRunOutPlayerId(playerId);

    // 选择跑杀球员后自动关闭模态框并处理出局
    if (playerId !== "") {
      handleWicket(true, playerId);
      setModalOpen(false);
      setOutType("");
      setRunOutPlayerId("");
      setShowRunOutPlayer(false);
      setShowRunOutPlayerError(false);
    }
  };
  const endMatch = () => {
    disableAllScoreButtons();
    if (inningNo === 2) {
      setEndInningDisabled(false);
    }
  };
  const disableAllScoreButtons = () => {
    setScoreButtonsDisabled(true);
  };
  const enableAllScoreButtons = () => {
    setScoreButtonsDisabled(false);
  };

  useEffect(() => {
    if (batter1?.name && batter2?.name && inputBowler) {
      enableAllScoreButtons();
    }
  }, [batter1.name, batter2.name, inputBowler]);

  let rrr = (remainingRuns / (remainingBalls / 6)).toFixed(2);
  rrr = isFinite(rrr) ? rrr : 0;
  const overs = overCount + ballCount / 6;
  let crr = (totalRuns / overs).toFixed(2);
  crr = isFinite(crr) ? crr : 0;
  const inning1 = match.inning1;
  const inning2 = match.inning2;
  const scoringTeam = batting === team1 ? team1 : team2;
  const chessingTeam = scoringTeam === team1 ? team2 : team1;

  let winningMessage = "";
  if (inningNo === 1) {
    winningMessage = t("scoreboard.status.needsRun", {
      team: scoringTeam,
      runs: remainingRuns,
      runWord: remainingRuns <= 1 ? t("units.run") : t("units.runs"),
      balls: remainingBalls,
      ballWord: remainingBalls <= 1 ? t("units.ball") : t("units.balls"),
    });
  } else {
    var target = inning1.runs + 1;
    if (wicketCount < 10 && overCount <= maxOver && totalRuns >= target) {
      winningMessage = t("scoreboard.status.wonByWickets", {
        team: chessingTeam,
        wickets: 10 - wicketCount,
      });
    } else if (
      (wicketCount >= 10 || overCount >= maxOver) &&
      totalRuns < target - 1
    ) {
      winningMessage = t("scoreboard.status.wonByRuns", {
        team: scoringTeam,
        runs: target - totalRuns - 1,
      });
    } else if (
      wicketCount < 10 &&
      overCount === maxOver &&
      totalRuns === target - 1
    ) {
      winningMessage = t("scoreboard.status.matchTied");
    } else {
      winningMessage = t("scoreboard.status.needsRun", {
        team: chessingTeam,
        runs: remainingRuns,
        runWord: remainingRuns <= 1 ? t("units.run") : t("units.runs"),
        balls: remainingBalls,
        ballWord: remainingBalls <= 1 ? t("units.ball") : t("units.balls"),
      });
    }
  }

  // 使用 useEffect 处理比赛结束逻辑，避免在渲染中直接调用
  useEffect(() => {
    if (inningNo === 2) {
      const target = (match.inning1?.runs || 0) + 1;
      const shouldEndMatch =
        (wicketCount < 10 && overCount <= maxOver && totalRuns >= target) ||
        ((wicketCount >= 10 || overCount >= maxOver) &&
          totalRuns < target - 1) ||
        (wicketCount < 10 && overCount === maxOver && totalRuns === target - 1);

      if (shouldEndMatch) {
        endMatch();
      }
    }
  }, [
    inningNo,
    match.inning1?.runs,
    totalRuns,
    wicketCount,
    overCount,
    maxOver,
    ballCount,
  ]);
  const welcomeContent = (
    <>
      <div></div>
      <div>{t("scoreboard.welcome.message")}</div>
      <div></div>
    </>
  );
  const firstInningCompletedContent = (
    <>
      {overCount === maxOver && (
        <div>{t("scoreboard.status.firstInningCompleted")}</div>
      )}
      {wicketCount === 10 && <div>{t("scoreboard.status.allOut")}</div>}
      <div>{t("scoreboard.status.endInningPrompt")}</div>
    </>
  );
  const remainingRunsContent = (
    <>
      <div>{t("scoreboard.status.target", { target })}</div>
      <div>{winningMessage}</div>
      <div>
        {t("scoreboard.score.requiredRunRate")}: {isNaN(rrr) ? 0 : rrr}
      </div>
    </>
  );
  return (
    <div className="container">
      <div className="inning">
        <div>
          {team1} vs {team2},{" "}
          {inningNo === 1
            ? t("scoreboard.inning.firstInning")
            : t("scoreboard.inning.secondInning")}
        </div>
        <div>
          <button id="end-inning" onClick={handleEndInning}>
            {inningNo === 1
              ? t("scoreboard.inning.endInning")
              : t("scoreboard.inning.scoreBoard")}
          </button>
        </div>
      </div>
      <div id="badge" className="badge badge-flex">
        {inningNo === 2
          ? remainingRunsContent
          : overCount === maxOver || wicketCount === 10
            ? firstInningCompletedContent
            : welcomeContent}
      </div>
      <div className="score-container">
        <div>
          <Modal
            open={isModalOpen}
            onClose={handleCloseModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={radioGroupBoxstyle}>
              <FormControl component="fieldset">
                <Grid container spacing={2} alignItems="center">
                  {/* 第一行 */}
                  <Grid item xs={4}>
                    <FormControlLabel
                      value={BOLD}
                      control={
                        <Radio
                          sx={{
                            "&.Mui-checked": {
                              color: pink[600],
                            },
                          }}
                          onChange={handleOutTypeChange}
                        />
                      }
                      label={BOLD}
                      sx={{ margin: 0 }}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <FormControlLabel
                      value={CATCH}
                      control={
                        <Radio
                          sx={{
                            "&.Mui-checked": {
                              color: pink[600],
                            },
                          }}
                          onChange={handleOutTypeChange}
                        />
                      }
                      label={CATCH}
                      sx={{ margin: 0 }}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <FormControlLabel
                      value={RUN_OUT}
                      control={
                        <Radio
                          sx={{
                            "&.Mui-checked": {
                              color: pink[600],
                            },
                          }}
                          onChange={handleOutTypeChange}
                        />
                      }
                      label={RUN_OUT}
                      sx={{ margin: 0 }}
                    />
                  </Grid>

                  {/* 第二行 */}
                  <Grid item xs={4}>
                    <FormControlLabel
                      value={STUMP}
                      control={
                        <Radio
                          sx={{
                            "&.Mui-checked": {
                              color: pink[600],
                            },
                          }}
                          onChange={handleOutTypeChange}
                        />
                      }
                      label={STUMP}
                      sx={{ margin: 0 }}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <FormControlLabel
                      value={HIT_WICKET}
                      control={
                        <Radio
                          sx={{
                            "&.Mui-checked": {
                              color: pink[600],
                            },
                          }}
                          onChange={handleOutTypeChange}
                        />
                      }
                      label={HIT_WICKET}
                      sx={{ margin: 0 }}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    {showRunOutPlayer && (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "4px",
                        }}
                      >
                        <FormControlLabel
                          value={batter1.id}
                          control={
                            <Radio
                              sx={{
                                "&.Mui-checked": {
                                  color: pink[600],
                                },
                                "& .MuiSvgIcon-root": {
                                  fontSize: 16,
                                },
                              }}
                              onChange={handleRunOutPlayerChange}
                            />
                          }
                          label={batter1.name}
                          sx={{
                            margin: 0,
                            "& .MuiFormControlLabel-label": {
                              fontSize: "0.75rem",
                            },
                          }}
                        />
                        <FormControlLabel
                          value={batter2.id}
                          control={
                            <Radio
                              sx={{
                                "&.Mui-checked": {
                                  color: pink[600],
                                },
                                "& .MuiSvgIcon-root": {
                                  fontSize: 16,
                                },
                              }}
                              onChange={handleRunOutPlayerChange}
                            />
                          }
                          label={batter2.name}
                          sx={{
                            margin: 0,
                            "& .MuiFormControlLabel-label": {
                              fontSize: "0.75rem",
                            },
                          }}
                        />
                      </div>
                    )}
                  </Grid>
                </Grid>
              </FormControl>
            </Box>
          </Modal>
        </div>
        <div className="score">
          <div>
            {inningNo === 1 ? scoringTeam : chessingTeam} : {totalRuns}/
            {wicketCount} ({totalOvers})
          </div>
          <div>CRR : {isNaN(crr) ? 0 : crr}</div>
        </div>
        <div className="batting-container">
          <table>
            <thead>
              <tr>
                <td className="score-types padding-left">
                  {t("scoreboard.batting.label")}
                </td>
                <td className="score-types">R(B)</td>
                <td className="score-types text-center">4s</td>
                <td className="score-types text-center">6s</td>
                <td className="score-types text-center">SR</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="score-types">
                  <span id="strike">
                    <Radio
                      size="small"
                      checked={strikeValue === "strike"}
                      onChange={handleStrikeChange}
                      value="strike"
                      name="radio-buttons"
                      inputProps={{ "aria-label": "strike" }}
                      style={{ padding: "0 4px 0 2px" }}
                    />
                  </span>
                  <input
                    type="text"
                    id="batter1Name"
                    className="batter-name"
                    value={batter1NameInput}
                    onChange={(e) => setBatter1NameInput(e.target.value)}
                    onBlur={handleBatter1Blur}
                    disabled={batter1NameDisabled}
                  />
                  <IconButton
                    color="primary"
                    className="icon-button"
                    onClick={editBatter1Name}
                  >
                    <EditIcon className="icon-size" />
                  </IconButton>
                </td>
                <td className="score-types">
                  {batter1.run === undefined
                    ? `0(0)`
                    : `${batter1.run}(${batter1.ball})`}
                </td>
                <td className="score-types">
                  {batter1.four === undefined ? 0 : batter1.four}
                </td>
                <td className="score-types">
                  {batter1.six === undefined ? 0 : batter1.six}
                </td>
                <td className="score-types">
                  {batter1.strikeRate === undefined ? 0 : batter1.strikeRate}
                </td>
              </tr>
              <tr>
                <td className="score-types">
                  <span id="non-strike">
                    <Radio
                      size="small"
                      checked={strikeValue === "non-strike"}
                      onChange={handleStrikeChange}
                      value="non-strike"
                      name="radio-buttons"
                      inputProps={{ "aria-label": "non-strike" }}
                      style={{ padding: "0 4px 0 2px" }}
                    />
                  </span>
                  <input
                    type="text"
                    id="batter2Name"
                    className="batter-name"
                    value={batter2NameInput}
                    onChange={(e) => setBatter2NameInput(e.target.value)}
                    onBlur={handleBatter2Blur}
                    disabled={batter2NameDisabled}
                  />
                  <IconButton
                    color="primary"
                    className="icon-button"
                    onClick={editBatter2Name}
                  >
                    <EditIcon className="icon-size" />
                  </IconButton>
                </td>
                <td className="score-types">
                  {batter2.run === undefined
                    ? `0(0)`
                    : `${batter2.run}(${batter2.ball})`}
                </td>
                <td className="score-types">
                  {batter2.four === undefined ? 0 : batter2.four}
                </td>
                <td className="score-types">
                  {batter2.six === undefined ? 0 : batter2.six}
                </td>
                <td className="score-types">
                  {batter2.strikeRate === undefined ? 0 : batter2.strikeRate}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="bowler-container">
          <div className="bowler">
            {t("scoreboard.bowling.label")}
            <Autosuggest
              suggestions={suggestions}
              onSuggestionsFetchRequested={onSuggestionsFetchRequested}
              onSuggestionsClearRequested={() => {
                setSuggestions([]);
              }}
              getSuggestionValue={getSuggestionValue}
              renderSuggestion={(suggestion) => <div>{suggestion.name}</div>}
              inputProps={inputProps}
            />
            <IconButton
              color="primary"
              className="icon-button"
              onClick={editBowlerName}
            >
              <EditIcon className="icon-size" />
            </IconButton>
          </div>
          <div className="bowler-runs">
            {currentRunStack.map((run, i) => (
              <div key={i}>{run}</div>
            ))}
            <IconButton
              color="warning"
              className="icon-button"
              onClick={undoDelivery}
            >
              <DeleteIcon className="delete-icon-size" />
            </IconButton>
          </div>
        </div>

        {/* 新的记分按钮区域 */}
        <div className="button-section">
          {/* 投手失误得分 */}
          <div className="button-group-title group-title-1">投手失误得分</div>
          <div className="button-row">
            {/* 宽球按钮 */}
            <button
              className="btn composite-btn btn-2-col"
              onClick={handleWideBasic}
              disabled={scoreButtonsDisabled}
            >
              <div
                className="sub-btn run-part"
                onClick={(e) => {
                  e.stopPropagation();
                  if (!scoreButtonsDisabled) handleWideExtrasClick();
                }}
              >
                跑
              </div>
              <div className="main-part">
                Wide
                <span>宽球</span>
              </div>
            </button>

            {/* 无效球按钮 */}
            <button
              className="btn composite-btn btn-2-col"
              onClick={handleNoBallBasic}
              disabled={scoreButtonsDisabled}
            >
              <div
                className="sub-btn run-part"
                onClick={(e) => {
                  e.stopPropagation();
                  if (!scoreButtonsDisabled) handleNoBallExtrasClick(false);
                }}
              >
                跑
              </div>
              <div className="main-part">
                No
                <span>无效球</span>
              </div>
              <div
                className="sub-btn hit-part"
                onClick={(e) => {
                  e.stopPropagation();
                  if (!scoreButtonsDisabled) handleNoBallExtrasClick(true);
                }}
              >
                击
              </div>
            </button>
          </div>

          {/* 守场失误得分 */}
          <div className="button-group-title">守场失误得分</div>
          <div className="button-row">
            <button
              className="btn btn-2-col"
              onClick={handleByeClick}
              disabled={scoreButtonsDisabled}
            >
              Bye
            </button>
            <button
              className="btn btn-2-col"
              onClick={handleLegByeClick}
              disabled={scoreButtonsDisabled}
            >
              Leg Bye
            </button>
          </div>

          {/* 常规得分 */}
          <div className="button-group-title">常规得分</div>
          <div className="button-row">
            <button
              className="btn btn-4-col"
              onClick={handlePenaltyRun}
              disabled={scoreButtonsDisabled}
            >
              {t("score.buttons.penalty", "罚分")}
            </button>
            <button
              className="btn btn-4-col"
              onClick={() => handleRun(1)}
              disabled={scoreButtonsDisabled}
            >
              1分
            </button>
            <button
              className="btn btn-4-col"
              onClick={() => handleRun(2)}
              disabled={scoreButtonsDisabled}
            >
              2分
            </button>
            <button
              className="btn btn-4-col"
              onClick={() => handleRun(3)}
              disabled={scoreButtonsDisabled}
            >
              3分
            </button>
          </div>
          <div className="button-row">
            <button
              className="btn btn-4-col"
              onClick={undoDelivery}
              disabled={scoreButtonsDisabled}
            >
              {t("score.buttons.undo", "撤销")}
            </button>
            <button
              className="btn btn-4-col"
              onClick={() => handleRun(4)}
              disabled={scoreButtonsDisabled}
            >
              4分
            </button>
            <button
              className="btn btn-4-col"
              onClick={() => handleRun(6)}
              disabled={scoreButtonsDisabled}
            >
              6分
            </button>
            <button
              className="btn btn-4-col"
              onClick={() => handleRun(0)}
              disabled={scoreButtonsDisabled}
            >
              0分
            </button>
          </div>

          <button
            className="btn btn-out"
            onClick={() => setModalOpen(true)}
            disabled={scoreButtonsDisabled}
          >
            {t("score.buttons.out", "OUT")}
          </button>
        </div>
        <div className="extras-container">
          <div>Extras: {extras.total}</div>
          <div>Wd: {extras.wide}</div>
          <div>NB: {extras.noBall}</div>
          <div>B: {extras.bye}</div>
          <div>LB: {extras.legBye}</div>
          <div>P: {extras.penalty || 0}</div>
        </div>
        <div className="recent-over-container">
          <div className="recent-over-text">
            {t("scoreboard.recentOvers.title")}
          </div>
          <div className="recent-over-details">
            <table>
              <tbody>
                {recentOvers.map((recentOver, i) => (
                  <tr key={i}>
                    <td>{recentOver.overNo}.</td>
                    <td>{recentOver.bowler}:</td>
                    <td>
                      <div className="recent-over-runs">
                        {recentOver.stack.map((run, index) => (
                          <div key={index}>{run}</div>
                        ))}
                      </div>
                    </td>
                    <td className="recent-over-total-run">
                      <div>{recentOver.runs}</div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="score-board-container">
          <div className="score-board-text text-center">
            {t("scoreboard.finalScoreBoard.title")}
          </div>
          {/* Inning1 Starts here */}
          <div>
            <div className="score-board-innings">
              <div>
                {scoringTeam} {t("scoreboard.finalScoreBoard.innings")}
              </div>
              <div>RR:{inningNo === 1 ? crr : inning1.runRate}</div>
              <div>
                {inningNo === 1 ? totalRuns : inning1.runs}-
                {inningNo === 1 ? wicketCount : inning1.wickets} (
                {inningNo === 1 ? totalOvers : inning1.overs} Ov)
              </div>
            </div>
            <div className="sb-batting">
              <table>
                <thead>
                  <tr>
                    <td className="score-types padding-left">Batsman</td>
                    <td className="score-types">R(B)</td>
                    <td className="score-types text-center">4s</td>
                    <td className="score-types text-center">6s</td>
                    <td className="score-types text-center">SR</td>
                  </tr>
                </thead>
                <tbody>
                  {inning1.batters.map((batter, i) => {
                    return (
                      <tr key={i}>
                        <td className="score-types padding-left">
                          {batter.name}
                        </td>
                        <td className="score-types">
                          {batter.run}({batter.ball})
                        </td>
                        <td className="score-types text-center">
                          {batter.four}
                        </td>
                        <td className="score-types text-center">
                          {batter.six}
                        </td>
                        <td className="score-types text-center">
                          {batter.strikeRate}
                        </td>
                      </tr>
                    );
                  })}
                  <tr>
                    <td className="score-types padding-left">Extras:</td>
                    <td className="score-types">
                      {inningNo === 1 ? extras.total : inning1.extra.total}
                    </td>
                    <td className="score-types text-center">
                      wd:{inningNo === 1 ? extras.wide : inning1.extra.wide}
                    </td>
                    <td className="score-types text-center">
                      nb:{inningNo === 1 ? extras.noBall : inning1.extra.noBall}
                    </td>
                    <td className="score-types text-center">
                      b:{inningNo === 1 ? extras.bye : inning1.extra.bye}
                    </td>
                    <td className="score-types text-center">
                      lb:{inningNo === 1 ? extras.legBye : inning1.extra.legBye}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="sb-bowling">
              <table>
                <thead>
                  <tr>
                    <td className="score-types padding-left">Bowler</td>
                    <td className="score-types">O</td>
                    <td className="score-types text-center">M</td>
                    <td className="score-types text-center">R</td>
                    <td className="score-types text-center">W</td>
                    <td className="score-types text-center">NB</td>
                    <td className="score-types text-center">WD</td>
                    <td className="score-types text-center">ECO</td>
                  </tr>
                </thead>
                <tbody>
                  {inning1.bowlers.map((blr, i) => {
                    const {
                      name,
                      over,
                      maiden,
                      run,
                      wicket,
                      noBall,
                      wide,
                      economy,
                    } = blr;
                    return (
                      <tr key={i}>
                        <td className="score-types padding-left">{name}</td>
                        <td className="score-types">{over}</td>
                        <td className="score-types text-center">{maiden}</td>
                        <td className="score-types text-center">{run}</td>
                        <td className="score-types text-center">{wicket}</td>
                        <td className="score-types text-center">{noBall}</td>
                        <td className="score-types text-center">{wide}</td>
                        <td className="score-types text-center">{economy}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
          {/* Inning2 Starts here */}
          {inningNo === 2 && (
            <div>
              <div className="score-board-innings">
                <div>
                  {chessingTeam} {t("scoreboard.finalScoreBoard.innings")}
                </div>
                <div>RR:{inningNo === 2 ? crr : inning2.runRate}</div>
                <div>
                  {hasMatchEnded ? inning2.runs : totalRuns}-
                  {hasMatchEnded ? inning2.wickets : wicketCount} (
                  {hasMatchEnded ? inning2.overs : totalOvers} Ov)
                </div>
              </div>
              <div className="sb-batting">
                <table>
                  <thead>
                    <tr>
                      <td className="score-types padding-left">Batsman</td>
                      <td className="score-types">R(B)</td>
                      <td className="score-types text-center">4s</td>
                      <td className="score-types text-center">6s</td>
                      <td className="score-types text-center">SR</td>
                    </tr>
                  </thead>
                  <tbody>
                    {inning2.batters.map((batter, i) => {
                      return (
                        <tr key={i}>
                          <td className="score-types padding-left">
                            {batter.name}
                          </td>
                          <td className="score-types">
                            {batter.run}({batter.ball})
                          </td>
                          <td className="score-types text-center">
                            {batter.four}
                          </td>
                          <td className="score-types text-center">
                            {batter.six}
                          </td>
                          <td className="score-types text-center">
                            {batter.strikeRate}
                          </td>
                        </tr>
                      );
                    })}
                    <tr>
                      <td className="score-types padding-left">Extras:</td>
                      <td className="score-types">
                        {hasMatchEnded ? inning2.extra.total : extras.total}
                      </td>
                      <td className="score-types text-center">
                        wd:{hasMatchEnded ? inning2.extra.wide : extras.wide}
                      </td>
                      <td className="score-types text-center">
                        nb:
                        {hasMatchEnded ? inning2.extra.noBall : extras.noBall}
                      </td>
                      <td className="score-types text-center">
                        b:{hasMatchEnded ? inning2.extra.bye : extras.bye}
                      </td>
                      <td className="score-types text-center">
                        lb:
                        {hasMatchEnded ? inning2.extra.legBye : extras.legBye}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="sb-bowling">
                <table>
                  <thead>
                    <tr>
                      <td className="score-types padding-left">Bowler</td>
                      <td className="score-types">O</td>
                      <td className="score-types text-center">M</td>
                      <td className="score-types text-center">R</td>
                      <td className="score-types text-center">W</td>
                      <td className="score-types text-center">NB</td>
                      <td className="score-types text-center">WD</td>
                      <td className="score-types text-center">ECO</td>
                    </tr>
                  </thead>
                  <tbody>
                    {inning2.bowlers.map((blr, i) => {
                      const {
                        name,
                        over,
                        maiden,
                        run,
                        wicket,
                        noBall,
                        wide,
                        economy,
                      } = blr;
                      return (
                        <tr key={i}>
                          <td className="score-types padding-left">{name}</td>
                          <td className="score-types">{over}</td>
                          <td className="score-types text-center">{maiden}</td>
                          <td className="score-types text-center">{run}</td>
                          <td className="score-types text-center">{wicket}</td>
                          <td className="score-types text-center">{noBall}</td>
                          <td className="score-types text-center">{wide}</td>
                          <td className="score-types text-center">{economy}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>

        {/* Extras面板 */}
        <ExtrasPanel
          open={showExtrasPanel}
          onClose={() => {
            setShowExtrasPanel(false);
            setExtrasType("");
          }}
          onSelect={handleExtrasSelect}
          title={t("score.extras.selectRuns", "记分规则")}
          subtitle={
            extrasType === "wide"
              ? t(
                  "score.extras.wideHint",
                  "得分 = wide + runs，分数计入团队分数",
                )
              : extrasType === "noball-run"
                ? t(
                    "score.extras.noBallHint",
                    "得分 = no + runs，分数计入团队分数",
                  )
                : extrasType === "noball-hit"
                  ? t(
                      "score.extras.noBallHitHint",
                      "得分 = no + runs，no计入团队分数，runs记入个人得分",
                    )
                  : extrasType === "bye"
                    ? t("选择跑分")
                    : t("score.extras.legByeHint", "选择跑分")
          }
          type={extrasType}
        />
      </div>
    </div>
  );
};

export default ScoreBoard;
